import React, { useState, useEffect, useRef } from 'react';
import Papa from 'papaparse';
import {
    Button,
    DateRangePicker,
    DownloadButton,
    LoadingComponent,
    Modal,
} from "../../../components/core";
import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { ContentContainer } from "../../../components/layout";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import {
    QUERY_REMOVAL_RATE,
} from "../../../constants/graphql/drop-off-graphql";

const LockerRemovalRate = () => {
    const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
    const [removalRates, setremovalRates] = useState([]);
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [searchResultHeader, setSearchResultHeader] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const dt = useRef(null);


    const [validation, setValidation] = useState({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "",
        message: "",
        open: false,
    });

    const [QUERYRemovalRate, { data, loading }] = useLazyQuery(
        QUERY_REMOVAL_RATE,
        { fetchPolicy: "no-cache" }
    );

    function handleSearchResultHeader() {
        setSearchResultHeader(`
      from ${formatDate(startDate)} to ${formatDate(endDate)}
      `)
    }

    const handleSearch = async () => {
        setisLoading(true);
        if (startDate == "" && endDate == "") {
            setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: "Invalid Date",
                message: `Please select a date range.`,
                open: true,
                actions: (
                    <div className="w-full">
                        <Button
                            onClick={() => setValidation({ open: false })}
                            value={"OK"}
                            className={"p-2 w-full"}
                        />
                    </div>
                ),
            });
            setisLoading(false);
            return;
        } else if (endDate == "") {
            setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: "Invalid Date",
                message: `No end date selected.`,
                open: true,
                actions: (
                    <div className="w-full">
                        <Button
                            onClick={() => setValidation({ open: false })}
                            value={"OK"}
                            className={"p-2 w-full"}
                        />
                    </div>
                ),
            });
            setisLoading(false);
            return;
        } else if (startDate > endDate) {
            setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: "Invalid Date",
                message: `Start date must be before end date.`,
                open: true,
                actions: (
                    <div className="w-full">
                        <Button
                            onClick={() => setValidation({ open: false })}
                            value={"OK"}
                            className={"p-2 w-full"}
                        />
                    </div>
                ),
            });
            setisLoading(false);
            return;
        } else if (startDate == "") {
            setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: "Invalid Date",
                message: `No start date selected.`,
                open: true,
                actions: (
                    <div className="w-full">
                        <Button
                            onClick={() => setValidation({ open: false })}
                            value={"OK"}
                            className={"p-2 w-full"}
                        />
                    </div>
                ),
            });
            setisLoading(false);
            return;
        }
        handleSearchResultHeader();
        QUERYRemovalRate({
            variables: {
                operatorId: operatorId,
                dateStart: startDate,
                dateEnd: endDate,
            },
        });
        setisLoading(false);

    }

    return (
        <ContentContainer containerTitle={"Locker Removal Rate Report"}>
            <div>
                <h1 className={"font-bold pb-2"}>Date range:</h1>
                <DateRangePicker
                    className={"w-1/2"}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(event) => {
                        if (event.target.name === "signupDateFrom") {
                            setStartDate(event.target.value);
                        } else {
                            setEndDate(event.target.value);
                        }
                    }}
                />
                <div className="grid grid-cols-2 w-1/2 gap-y-2">
                    <div></div>
                    <u
                        className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
                        onClick={() => {
                            setStartDate(new Date().toISOString().split('T')[0]);
                            setEndDate(new Date().toISOString().split('T')[0]);
                        }}
                    >
                        <i className="fas fa-undo my-auto"></i>
                        <p className="ml-1">Reset</p>
                    </u>
                </div>

                <Button
                    value={"Search"}
                    onClick={handleSearch}
                    className={"w-40 h-8 m-4 cursor-pointer"}
                />
                {isLoading && <LoadingComponent />}
                {

                }
            </div>
            <Modal
                icon={validation.icon}
                title={validation.title}
                message={validation.message}
                open={validation.open}
                actions={validation.actions}
            />
        </ContentContainer >
    );
};

export default LockerRemovalRate;

function formatDate(inputDate) {
    if (inputDate == null) {
        return "";
    }
    const date = new Date(inputDate);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
}